/** Shared constants for Who Wants to Be a Millionaire. */

export const QUESTION_COUNT = 15;
export const DEFAULT_TOP_PRIZE = 1_000_000;
export const SAFE_HAVEN_INDICES = [4, 9]; // Q5 and Q10 (0-based)
export const MIN_PLAYER_AGE = 3;
export const MAX_PLAYER_AGE = 99;

export const DIFFICULTIES = [
  { id: "easy", label: "Easy" },
  { id: "medium", label: "Medium" },
  { id: "hard", label: "Hard" }
];

export const CHOICE_LETTERS = ["A", "B", "C", "D"];

/** Seconds allowed per question by ladder index (0–14). */
export const TIMER_SECONDS_BY_INDEX = [
  45, 45, 45, 45, 45, // Q1–5
  60, 60, 60, 60, 60, // Q6–10
  90, 90, 90, 90, 90 // Q11–15
];

export const PHONE_FRIEND_SECONDS = 45;

export const DEFAULT_MODIFIERS = {
  unlimitedTime: false,
  showExplanations: true,
  extraHardFinal5: false,
  disableFiftyFifty: false,
  disablePhoneFriend: false,
  disableAudience: false
};

/**
 * Age band for Grok prompting.
 * @param {number} age
 * @returns {"preschool"|"elementary"|"teen"|"adult"}
 */
export function ageBand(age) {
  const n = Number(age);
  if (n <= 7) return "preschool";
  if (n <= 12) return "elementary";
  if (n <= 17) return "teen";
  return "adult";
}

export const AGE_BAND_LABELS = {
  preschool: "Ages 3–7 (preschool / early elementary)",
  elementary: "Ages 8–12 (elementary / middle)",
  teen: "Ages 13–17 (teen)",
  adult: "Ages 18+ (adult, family-safe)"
};

/**
 * Format a prize amount for display.
 * @param {number} amount
 * @returns {string}
 */
export function formatMoney(amount) {
  const n = Number(amount) || 0;
  if (n >= 1 || n === 0) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0
    }).format(Math.round(n));
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(n);
}
